import React, {Component} from 'react';
import {
  StyleSheet,
  View,
  Platform,
  Text,
  Linking,
  Dimensions,
  TouchableOpacity,
  Image,
  Alert,
  TextInput,
  I18nManager,
} from 'react-native';
import colors from '../HelperClasses/AppColor';
import tlogo from '../assets/tradlyicon.png';
import help_Icon from '../assets/helpIcon.png';
import user_Icon from '../assets/userIcon.png';
import switch_Icon from '../assets/switch.png';
import menu_Icon from '../assets/menuIcon.png';
import more_Iocn from '../assets/moreIocn.png';
import openLinkIcon from '../assets/openLinkIcon.png';
import logoutIcon from '../assets/u_sign-out-alt.png';
import launchpadIcon from '../assets/launchpadIcon.png';
import billingIcon from '../assets/billingIcon.png';
import box_icon from '../assets/u_box.png';
import palete_icon from '../assets/u_palette.png';
import inviteTeamIcon from '../assets/inviteTeamIcon.png';
import apiRefIcon from '../assets/apiRefIcon.png';
import communityIcon from '../assets/communityIcon.png';
import aiStudioIcon from '../assets/aiStudio.png';
import communityIcon2 from '../assets/communityIconMenu.png';
import documentationIcon from '../assets/documentationIcon.png';
import documentationIcon2 from '../assets/docsIconMenu.png';
import inviteIcon from '../assets/inviteIcon.png';
import networkService from '../Network/NetworkManager';
import Appload from '../HelperClasses/AppLoaderClasses/AppLoader';
import Switch from 'react-switch';
import dollar_Icon from '../assets/gift.png';
import gift_icon from '../assets/gift.png';

import PropTypes from 'prop-types';
import AppConstants from '../Constants/AppConstants';
import {
  addMixpanelEvent,
  MixpanelEvent,
  MixPannelEnum,
  resetMixpanel,
} from '../Models/MixPannelEnum';
import {
  getCookiesValue,
  getValuesFromCookies,
  saveCookies,
} from '../HelperClasses/UserPrefrences';
import {ProjectTypeModel} from '../Models/ProjectTypeModel';
import CommonStyleSheet from '../StyleSheets/CommonStyleSheet';
import TextTitleStyleSheet from '../StyleSheets/TextTitleStyleSheet';
import tableStyle from '../StyleSheets/TableCommonStyleSheet';
import PreviewButton from './PreviewButton';
import {editor_icon} from '../Constants/SVG';
import {logout} from '../HelperClasses/SingletonClass';
import {withRouter} from '../wrappers/withRouter';
import IconButton from './UI/buttons/NormalButton';
import {ICONS} from '../Constants/Icons';
import TenantChangeButton from './SiteList/TenantChangeButton';
import LocaleSelector from './LocaleSelector';
import AICreditsControl from './AICreditsControl';
import PrimaryButton from '../UI/Buttons/PrimaryButton';
import SaveButton from '../UI/Buttons/SaveButton';
import {withLocale} from '../Localization/LocaleContext';
import {ThemeContext} from '../HelperClasses/ThemeContext';
const APPConstants = require('../Constants/AppConstants');
const APPURL = require('../Constants/URLConstants');

const windowWidth = Dimensions.get('window').width;
let fixedWidth = AppConstants.mobileMaxWidth;

class AppNavigationHeader extends Component {
  static contextType = ThemeContext;
  t = (key, paramsOrFallback, fallback) => this.props.localeContext?.translate?.(key, paramsOrFallback, fallback) || fallback || paramsOrFallback || key;

  //Main View defined under this Class
  constructor() {
    super();
    this.state = {
      updateUI: false,
      showLogoutView: false,
      showHelpView: false,
      showInviteView: false,
      openMenu: true,
      envSwitch: false,
      email: '',
      name: '',
      moreOpen: false,
    };
  }
  static propTypes = {
    menuBtnAction: PropTypes.func,
    logoutBtnAction: PropTypes.func,
    QuickStartBtn: PropTypes.func,
    OpenMenuBar: PropTypes.bool,
    changeEvnBtn: PropTypes.func,
  };

  componentDidMount() {
    let evn = getCookiesValue(AppConstants.tradlyEVN);
    this.setState({envSwitch: evn == 'sandbox' ? true : false});
  }
  inviteMemberApi = async () => {
    var dict = {
      name: this.state.name,
      email: this.state.email,
    };
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.inviteMember,
      'post',
      JSON.stringify({sub_user: dict}),
    );
    console.log('inviteMember responseJson', responseJson);
    if (responseJson['status'] == true) {
      this.setState({name: '', email: ''});
    } else {
      alert(responseJson);
    }
  };
  mixpanelInfo(value) {
    addMixpanelEvent(MixpanelEvent.headerMenu, {Action: value});
  }
  //MARK:- Buttons
  inviteBtnAction() {
    if (this.state.name.length == 0) {
      alert(this.t('navigation.invite_name_required', 'Please fill in the name'));
    } else if (this.state.email.length == 0) {
      alert(this.t('navigation.invite_email_required', 'Please fill in the email'));
    } else {
      this.setState({showInviteView: false});
      this.inviteMemberApi();
    }
  }
  helpBtnAction = async id => {
    this.setState({showHelpView: false, showLogoutView: false});
    if (id == 4) {
      this.props.navigate?.('/workspace/plans');
      return;
    }
    var pathURL = APPConstants.communityURL;
    if (id != 3) {
      if (id == 5) {
        pathURL = APPConstants.apiRefrenceLink;
        this.mixpanelInfo(MixPannelEnum.apiReference);
      } else if (id == 6) {
        pathURL = APPConstants.launchpadURL;
      } else if (id == 7) {
        pathURL = APPConstants.workspace;
      } else if (id == 8) {
        pathURL = APPConstants.editor;
      } else if (id == 9) {
        pathURL = APPConstants.marketplace;
      } else if (id == 10) {
        pathURL = APPConstants.communityURL;
      } else if (id == 11) {
        pathURL = APPConstants.docsURL;
      } else if (id == 12) {
        pathURL = APPConstants.workflows;
      } else if (id == 13) {
        pathURL = APPConstants.aiStudio;
      } else if (id == 14) {
        pathURL = APPConstants.webAnalytics;
      } else if (id == 15) {
        pathURL = `${APPConstants.workspace}cms`;
      } else if (id == 16) {
        pathURL = 'https://tradly.app/mcp';
      } else {
        this.mixpanelInfo(
          id == 1 ? MixPannelEnum.documentation : MixPannelEnum.communityURL,
        );
        pathURL = id == 1 ? APPConstants.docsURL : APPConstants.supportURL;
      }
    } else {
      this.mixpanelInfo(MixPannelEnum.community);
    }
    if (Platform.OS == 'web') {
      window.open(pathURL, '_blank');
    } else {
      const supported = await Linking.canOpenURL(pathURL);
      if (supported) {
        await Linking.openURL(pathURL, '_blank');
      } else {
          Alert.alert(this.t('navigation.open_url_failed', {url: pathURL}, "Don't know how to open this URL: {url}"));
      }
    }
  };
  logoutBtnActions() {
    resetMixpanel();
    this.setState({showLogoutView: false});
    logout();
  }
  menuBtnClassAction() {
    this.setState({openMenu: !this.state.openMenu});
  }
  closeMenuBtnAction() {
    this.setState({openMenu: true});
  }
  environmentBtnAction() {
    let evn = this.state.envSwitch ? 'production' : 'sandbox';
    this.mixpanelInfo(evn);
    saveCookies(AppConstants.tradlyEVN, evn);
    this.setState({envSwitch: !this.state.envSwitch});
  }
  onMouseLeave() {
    this.setState({
      showHelpView: false,
      showLogoutView: false,
      showInviteView: false,
    });
  }
  languageBtnAction() {
    const currentLocale = this.props.localeContext?.locale || 'en';
    this.props.localeContext?.setLocale?.(currentLocale === 'ar' ? 'en' : 'ar');
  }
  //MARK:-  UIs
  menuButtonRender = () => {
    if (windowWidth < fixedWidth) {
      return (
        <TouchableOpacity onPress={() => this.menuBtnClassAction()}>
          <Image
            style={styles.menuBtnStyle}
            source={menu_Icon}
            resizeMode="contain"
          />
        </TouchableOpacity>
      );
    } else {
      return <View />;
    }
  };
  logoutView = () => {
    if (this.state.showLogoutView) {
      return (
        <View
          style={styles.logoutView}
          onMouseLeave={() => this.onMouseLeave()}>
          {/*  <TouchableOpacity onPress={() => this.helpBtnAction(6)} style={styles.openLinkStyle}>
            <Image source={launchpadIcon} style={styles.linkiconstyle} />
            <Text style={{ margin: 10,width:110 }}>Launchpad</Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity> */}
          <TouchableOpacity
            onPress={() => this.helpBtnAction(7)}
            style={styles.openLinkStyle}>
            <Image source={box_icon} style={styles.iconStyle} />
            <Text
              numberOfLines={1}
              style={{
                marginLeft: 10,
                marginRight: 10,
                width: 130,
                paddingTop: 10,
                paddingBottom: 10,
              }}>
              {this.t('navigation.workspace', 'Workspace')}
            </Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.helpBtnAction(8)}
            style={styles.openLinkStyle}>
            <Image source={palete_icon} style={styles.iconStyle} />
            <Text
              style={{
                marginLeft: 10,
                marginRight: 10,
                width: 130,
                paddingTop: 10,
                paddingBottom: 10,
              }}>
              {this.t('navigation.editor', 'Editor')}
            </Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity>
          {/* Marketplace is temporarily hidden from the product launcher. */}
          <TouchableOpacity
            onPress={() => this.helpBtnAction(12)}
            style={styles.openLinkStyle}>
            <Image source={ICONS.adBanner_Icon} style={styles.iconStyle} />
            <Text
              style={{
                marginLeft: 10,
                marginRight: 10,
                width: 130,
                paddingTop: 10,
                paddingBottom: 10,
              }}>
              {this.t('navigation.marketing', 'Marketing')}
            </Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.helpBtnAction(14)}
            style={styles.openLinkStyle}>
            <Image source={ICONS.webIcon} style={styles.iconStyle} />
            <Text
              style={{
                marginLeft: 10,
                marginRight: 10,
                width: 130,
                paddingTop: 10,
                paddingBottom: 10,
              }}>
              {this.t('navigation.web_analytics', 'Web Analytics')}
            </Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.helpBtnAction(13)}
            style={styles.openLinkStyle}>
            <Image source={aiStudioIcon} style={styles.iconStyle} />
            <Text
              style={{
                marginLeft: 10,
                marginRight: 10,
                width: 130,
                paddingTop: 10,
                paddingBottom: 10,
              }}>
              {this.t('navigation.ai_studio', 'AI Studio')}
            </Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity>
          {/* Community is temporarily hidden from the product launcher. */}
          <TouchableOpacity
            onPress={() => this.helpBtnAction(11)}
            style={styles.openLinkStyle}>
            <Image source={documentationIcon2} style={styles.iconStyle} />
            <Text
              style={{
                marginLeft: 10,
                marginRight: 10,
                width: 130,
                paddingTop: 10,
                paddingBottom: 10,
              }}>
              {this.t('navigation.docs', 'Docs')}
            </Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.logoutBtnActions()}
            style={styles.openLinkStyle}>
            <Image source={logoutIcon} style={styles.iconStyle} />
            <Text
              style={{
                marginLeft: 10,
                marginRight: 10,
                width: 130,
                paddingTop: 10,
                paddingBottom: 10,
              }}>
              {this.t('navigation.logout', 'Logout')}
            </Text>
          </TouchableOpacity>
          <View
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,

              paddingBottom: 4,
            }}>
            <TenantChangeButton />
            <Text
              style={{
                paddingLeft: 10,
                paddingRight: 10,
                color: 'var(--color-text-secondary)',
              }}>
              {AppConstants.tenantName}{' '}
              <span className="text-xs text-gray-600">{this.t('navigation.tenant_name_placeholder', '(Tenant name)')}</span>
            </Text>
            <Text
              style={{
                paddingLeft: 10,
                paddingRight: 10,
                color: 'var(--color-text-secondary)',
              }}>
              {AppConstants.userFullName}{' '}
              <span className="text-xs text-gray-600">{this.t('navigation.username_placeholder', '(Username)')}</span>
            </Text>
          </View>
        </View>
      );
    } else {
      return <View />;
    }
  };
  ecosystemMenu = () => {
    if (!this.state.showLogoutView) {
      return <View />;
    }

    const isDark = this.context?.isDark;
    const isRTL = this.props.localeContext?.locale === 'ar';
    const menuColors = {
      background: 'var(--color-bg)',
      border: 'var(--color-border)',
      text: 'var(--color-text)',
      muted: 'var(--color-text-secondary)',
      iconBackground: 'var(--color-input)',
    };

    const kits = [
      {
        number: '01',
        title: 'BuildKit',
        color: '#6E9CF7',
        items: [
          {title: 'No-code editor', key: 'navigation.no_code_editor', icon: palete_icon, action: 8},
          {title: 'Vibe coding', key: 'navigation.vibe_coding', icon: aiStudioIcon, action: 13},
          {title: 'API/SDK', key: 'navigation.api_sdk', icon: apiRefIcon, action: 5},
        ],
      },
      {
        number: '02',
        title: 'OpsKit',
        color: '#6ED19D',
        items: [
          {title: 'Workspace', key: 'navigation.workspace', icon: box_icon, action: 7},
          {title: 'CMS', key: 'navigation.cms', icon: documentationIcon2, action: 15},
        ],
      },
      {
        number: '03',
        title: 'GrowthKit',
        color: '#F1C854',
        items: [
          {title: 'Marketing automation', key: 'navigation.marketing_automation', icon: ICONS.adBanner_Icon, action: 12},
          {title: 'Analytics & Recommendation', key: 'navigation.analytics_recommendation', icon: ICONS.webIcon, action: 14},
        ],
      },
      {
        number: '04',
        title: 'AIKit',
        color: '#B5A0F2',
        items: [
          {title: 'AI Studio (Iryxo)', key: 'navigation.ai_studio_iryxo', icon: aiStudioIcon, action: 13},
          {title: 'Tradly MCP', key: 'navigation.tradly_mcp', icon: apiRefIcon, action: 16},
        ],
      },
    ];

    return (
      <View
        style={[styles.ecosystemMenu, {
          backgroundColor: menuColors.background,
          borderColor: menuColors.border,
          left: isRTL ? 0 : undefined,
          right: isRTL ? undefined : 0,
        }]}
        onMouseLeave={() => this.onMouseLeave()}>
        {kits.map(kit => (
          <View key={kit.title} style={[styles.ecosystemKit, {borderColor: menuColors.border}]}>
            <View style={styles.ecosystemKitHeader}>
              <View>
                <Text style={[styles.ecosystemNumber, {color: menuColors.muted}]}>{kit.number}</Text>
                <Text style={[styles.ecosystemKitTitle, {color: menuColors.text}]}>{kit.title}</Text>
              </View>
              <View style={[styles.ecosystemDot, {backgroundColor: kit.color}]} />
            </View>
            {kit.items.map(item => (
              <TouchableOpacity
                key={item.title}
                style={styles.ecosystemItem}
                onPress={() => this.helpBtnAction(item.action)}>
                <View style={[styles.ecosystemIconBox, {borderColor: menuColors.border, backgroundColor: menuColors.iconBackground}]}>
                  <Image
                    source={item.icon}
                    style={styles.ecosystemIcon}
                    resizeMode="contain"
                    accessibilityLabel={item.title}
                  />
                </View>
                <Text style={[styles.ecosystemItemTitle, {color: menuColors.text}]} numberOfLines={2}>
                  {this.t(item.key, item.title)}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        ))}
        <View style={[styles.ecosystemAccountFooter, {borderTopColor: menuColors.border}]}>
          <View style={styles.ecosystemAccountDetails}>
            <Text style={[styles.ecosystemTenantName, {color: menuColors.text}]} numberOfLines={1}>
              {AppConstants.tenantName || this.t('navigation.current_project', 'Current project')}
            </Text>
            <Text style={[styles.ecosystemUserName, {color: menuColors.muted}]} numberOfLines={1}>
              {AppConstants.userFullName || this.t('navigation.current_user', 'Current user')}
            </Text>
          </View>
          <View style={styles.ecosystemAccountActionsRow}>
          <LocaleSelector compact textColor={menuColors.text} borderColor={menuColors.border} />
          <TouchableOpacity
            onPress={() => this.context?.toggleTheme()}
            style={styles.ecosystemThemeAction}
            accessibilityLabel={
              this.t(isDark ? 'navigation.switch_to_light_mode' : 'navigation.switch_to_dark_mode', isDark ? 'Switch to light mode' : 'Switch to dark mode')
            }>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke={menuColors.text}
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round">
              {isDark ? (
                <>
                  <circle cx="12" cy="12" r="4" />
                  <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42" />
                </>
              ) : (
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              )}
            </svg>
          </TouchableOpacity>
          <TenantChangeButton darkMode={isDark} />
          <TouchableOpacity
            onPress={() => this.logoutBtnActions()}
            style={styles.ecosystemAccountAction}>
            <Image source={logoutIcon} style={styles.ecosystemAccountIcon} />
            <Text style={[styles.ecosystemAccountActionText, {color: menuColors.text}]}>{this.t('navigation.logout', 'Logout')}</Text>
          </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  };
  helpView = () => {
    if (this.state.showHelpView) {
      return (
        <View
          style={styles.logoutView}
          onMouseLeave={() => this.onMouseLeave()}>
          <TouchableOpacity
            onPress={() => this.helpBtnAction(1)}
            style={styles.openLinkStyle}>
            <Image source={documentationIcon} style={styles.iconStyle} />
            <Text style={{margin: 10, width: 100}}>{this.t('navigation.documentation', 'Documentation')}</Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity>
          {/* <TouchableOpacity onPress={() => this.helpBtnAction(2)}>
            <Text style={{margin: 10}}>Support Portal</Text>
          </TouchableOpacity> */}
          <TouchableOpacity
            onPress={() => this.helpBtnAction(3)}
            style={styles.openLinkStyle}>
            <Image source={communityIcon} style={styles.iconStyle} />
            <Text style={{margin: 10, width: 100}}>{this.t('navigation.community', 'Community')}</Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.helpBtnAction(5)}
            style={styles.openLinkStyle}>
            <Image source={apiRefIcon} style={styles.iconStyle} />
            <Text style={{margin: 10, width: 100}}>{this.t('navigation.api_reference', 'API Reference')}</Text>
            <Image source={openLinkIcon} style={styles.openLinkconstyle} />
          </TouchableOpacity>
        </View>
      );
    } else {
      return <View />;
    }
  };
  renderInviteMember = () => {
    if (this.state.showInviteView) {
      return (
        <View style={{marginTop: -10, zIndex: 234239}}>
          <View
            style={[
              styles.logoutView,
              {height: 300, width: windowWidth < fixedWidth ? 300 : 500},
            ]}>
            <View
              style={{
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                padding: 10,
              }}>
              <Text style={CommonStyleSheet.inviteMemberTitleStyle}>
                {this.t('navigation.invite_team', 'Invite Team')}
              </Text>
              <View style={{height: 10}} />
              <Text style={CommonStyleSheet.inviteMemberSubTitleStyle}>
                {this.t('navigation.invite_description', 'Send invitation links to team members')}
              </Text>
              <TextInput
                style={[CommonStyleSheet.emailTextFieldStyle, {outline: 0}]}
                placeholder={this.t('common.name', 'Name')}
                placeholderTextColor={colors.placeholderColor}
                value={this.state.name}
                onChangeText={text => this.setState({name: text})}
              />
              <TextInput
                style={[
                  CommonStyleSheet.emailTextFieldStyle,
                  {outline: 0, marginTop: 40},
                ]}
                placeholder={this.t('common.email', 'Email')}
                placeholderTextColor={colors.placeholderColor}
                value={this.state.email}
                onChangeText={text => this.setState({email: text})}
              />
              <View
                style={{
                  marginTop: 40,
                  width: '90%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexDirection: 'row',
                }}>
                <TouchableOpacity
                  onPress={() =>
                    this.setState({showInviteView: !this.state.showInviteView})
                  }>
                  <Text
                    style={[
                      CommonStyleSheet.commonBtnTxtStyle,
                      {marginTop: 10},
                    ]}>
                    {this.t('common.close', 'Close')}
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.inviteBtnStyle}
                  onPress={() => this.inviteBtnAction()}>
                  <Text style={CommonStyleSheet.applyNxtBtnStyle}>{this.t('navigation.invite', 'Invite')}</Text>
                  <Image
                    style={styles.inviteIconStyle}
                    source={inviteIcon}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      );
    } else {
      return <View />;
    }
  };

  renderEnvironmentButtonView = () => {
    if (!APPConstants.isDevelopment) {
      return (
        <View
          style={{flexDirection: 'row', alignItems: 'center', marginLeft: 10}}>
          <Text style={CommonStyleSheet.testModeTextStyle}>{this.t('navigation.test_mode', 'Test Mode')}</Text>
          <Switch
            onColor={colors.AppNewGreen}
            onChange={() => this.environmentBtnAction()}
            checked={this.state.envSwitch}
            height={22}
            width={50}
          />
        </View>
      );
    } else {
      return <View />;
    }
  };
  rendeMoreView = () => {
    if (windowWidth < fixedWidth) {
      if (this.state.moreOpen) {
        return (
          <View style={styles.moreViewContainerStyle}>
            {this.renderHeaderRightView()}
            <TouchableOpacity onPress={() => this.setState({moreOpen: false})}>
              <Text
                style={[CommonStyleSheet.commonBtnTxtStyle, {marginRight: 10}]}>
                {this.t('common.close', 'Close')}
              </Text>
            </TouchableOpacity>
            <View style={{height: 10}} />
          </View>
        );
      } else {
        return (
          <View style={{width: '100%', alignItems: 'flex-end'}}>
            <TouchableOpacity onPress={() => this.setState({moreOpen: true})}>
              <Image
                style={styles.menuBtnStyle}
                source={more_Iocn}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        );
      }
    } else {
      return (
        <View style={{flex: 0, paddingTop: 5}}>
          {this.renderHeaderRightView()}
        </View>
      );
    }
  };
  renderLanguageButtonView = () => {
    const lang = this.props.localeContext?.locale || 'en';
    return (
      <View
        style={{
          display:
            AppConstants.projectType == ProjectTypeModel.delivery
              ? 'flex'
              : 'none',
          flexDirection: 'row',
          alignItems: 'center',
          marginLeft: 20,
        }}>
        <Text style={CommonStyleSheet.testModeTextStyle}>
          {this.t('common.language', 'Language')}({lang})
        </Text>
        <Switch
          onColor={colors.AppNewGreen}
          onChange={() => this.languageBtnAction()}
          checked={lang === 'ar'}
          height={22}
          width={50}
        />
      </View>
    );
  };
  renderHeaderRightView = () => {
    const themeColors = this.context?.colors ?? colors;
    const isSidebar = !!this.props.sidebar;
    const isExpand = this.props.isExpand !== false;
    const isMobileUpgradeOnly = !!this.props.mobileUpgradeOnly;

    // Mobile top bar: only render the Upgrade button
    if (isMobileUpgradeOnly) {
      return (
        <TouchableOpacity
          style={[tableStyle.secondButtonViewStyle, {
            backgroundColor: 'var(--color-input)',
            borderColor: 'var(--color-accent)',
          }]}
          onPress={() => this.helpBtnAction(4)}>
          <Text style={[tableStyle.secondBtnTextStyle, {fontSize: 12, padding: 5}]}>{this.t('navigation.upgrade', 'Upgrade')}</Text>
        </TouchableOpacity>
      );
    }

    // Mobile full bar: app icons + YouTube + switcher
    if (this.props.mobileFull) {
      return (
        <View style={{flexDirection: 'row', alignItems: 'center', gap: 2}}>
          <IconButton
            onClick={() => {
              addMixpanelEvent(MixpanelEvent.app_download, {[MixPannelEnum.device]: 'Android'});
              window.open('https://play.google.com/store/apps/details?id=tradly.app', '_blank');
            }}
            icon={ICONS.play_store_icon}
            ariaLabel={this.t('navigation.download_android_app', 'Download Android app')}
          />
          <IconButton
            onClick={() => {
              addMixpanelEvent(MixpanelEvent.app_download, {[MixPannelEnum.device]: 'IOS'});
              window.open('https://apps.apple.com/us/app/tradly-superadmin/id6756290651', '_blank');
            }}
            icon={ICONS.app_store_icon}
            ariaLabel={this.t('navigation.download_ios_app', 'Download iOS app')}
          />
          <IconButton
            onClick={() => {
              addMixpanelEvent(MixpanelEvent.headerMenu, {Action: 'Youtube clicked'});
              window.open('https://www.youtube.com/channel/UCRpXlfFBX5nayubY70-IFEA', '_blank');
            }}
            icon={ICONS.youtube_icon}
            ariaLabel={this.t('navigation.subscribe_youtube', 'Subscribe on YouTube')}
          />
          <View style={{marginLeft: 2, zIndex: 938}}>
            <TouchableOpacity
              onPress={() =>
                this.setState({
                  showLogoutView: !this.state.showLogoutView,
                  showHelpView: false,
                })
              }>
              <Image
                resizeMode="center"
                style={{height: 20, width: 20}}
                source={switch_Icon}
                accessibilityLabel={this.t('navigation.open_app_switcher', 'Open app switcher')}
              />
            </TouchableOpacity>
            <this.ecosystemMenu />
          </View>
        </View>
      );
    }

    return (
      <View style={[
        styles.headerContentView,
        isSidebar
          ? {flexDirection: 'column', alignItems: 'flex-start', gap: 2, paddingHorizontal: 6, paddingBottom: 8}
          : {gap: 12},
      ]}>
        {/* {this.renderEnvironmentButtonView()} */}
        {/* <View
          style={[
            styles.tickViewStyle,
            {
              marginLeft: isComplete ? 10 : 0,
              display: isComplete ? 'flex' : 'none',
            },
          ]}>
         
        </View> */}
        {/* <TouchableOpacity
          onPress={() =>
            this.setState({
              showInviteView: !this.state.showInviteView,
              showLogoutView: false,
              showHelpView: false,
            })
          }>
          <Image
            resizeMode={'center'}
            style={{height: 24, width: 24}}
            source={inviteTeamIcon}
          />
        </TouchableOpacity> */}
        <AICreditsControl sidebar={isSidebar} isExpand={isExpand} />
        {/* Upgrade — compact button; full-width only in top bar */}
        {(!isSidebar || isExpand) && (
          <TouchableOpacity
            style={[
              isSidebar
                ? {flexDirection: 'row', alignItems: 'center', gap: 6, paddingHorizontal: 12, paddingVertical: 7, borderRadius: 8,
                    backgroundColor: 'var(--color-input)',
                    borderColor: 'var(--color-accent)',
                    borderWidth: 1, alignSelf: 'flex-start'}
                : [tableStyle.secondButtonViewStyle, {
                    backgroundColor: 'var(--color-input)',
                    borderColor: 'var(--color-accent)',
                    marginRight: 6,
                  }],
            ]}
            onPress={() => this.helpBtnAction(4)}>
            <Text style={[tableStyle.secondBtnTextStyle, {fontSize: 12, padding: isSidebar ? 0 : 5}]}>{this.t('navigation.upgrade', 'Upgrade')}</Text>
          </TouchableOpacity>
        )}
        {/* Icon links — sidebar: compact horizontal row when expanded; top bar: individual items */}
        {isSidebar ? (
          isExpand && (
            <View style={{flexDirection: 'row', gap: 2, paddingHorizontal: 2, paddingTop: 2}}>
              <IconButton
                onClick={() => {
                  addMixpanelEvent(MixpanelEvent.app_download, {[MixPannelEnum.device]: 'Android'});
                  window.open('https://play.google.com/store/apps/details?id=tradly.app', '_blank');
                }}
                icon={ICONS.play_store_icon}
                ariaLabel={this.t('navigation.open_android_app', 'Open Android app')}
                className=""
              />
              <IconButton
                onClick={() => {
                  addMixpanelEvent(MixpanelEvent.app_download, {[MixPannelEnum.device]: 'IOS'});
                  window.open('https://apps.apple.com/us/app/tradly-superadmin/id6756290651', '_blank');
                }}
                icon={ICONS.app_store_icon}
                ariaLabel={this.t('navigation.open_ios_app', 'Open iOS app')}
                className=""
              />
              <IconButton
                onClick={() => {
                  addMixpanelEvent(MixpanelEvent.llm_support, {[MixPannelEnum.bots]: 'ChatGPT'});
                  window.open('https://chatgpt.com/g/g-68ee1e210830819198cf35315ee7eeac-tradly-support', '_blank');
                }}
                icon={ICONS.chat_gpt_icon}
                ariaLabel={this.t('navigation.open_ai_support', 'Open Tradly ChatGPT support')}
                className=""
              />
              <IconButton
                onClick={() => {
                  addMixpanelEvent(MixpanelEvent.headerMenu, {Action: 'Youtube clicked'});
                  window.open('https://www.youtube.com/channel/UCRpXlfFBX5nayubY70-IFEA', '_blank');
                }}
                icon={ICONS.youtube_icon}
                ariaLabel={this.t('navigation.open_youtube_channel', 'Open Tradly YouTube channel')}
                className=""
              />
            </View>
          )
        ) : (
          <>
            <IconButton
              onClick={() => {
                addMixpanelEvent(MixpanelEvent.app_download, {[MixPannelEnum.device]: 'Android'});
                window.open('https://play.google.com/store/apps/details?id=tradly.app', '_blank');
              }}
              icon={ICONS.play_store_icon}
              ariaLabel={this.t('navigation.open_android_app', 'Open Android app')}
              className="-mr-1 hidden md:block"
              color="var(--sidebar-text)"
            />
            <IconButton
              onClick={() => {
                addMixpanelEvent(MixpanelEvent.app_download, {[MixPannelEnum.device]: 'IOS'});
                window.open('https://apps.apple.com/us/app/tradly-superadmin/id6756290651', '_blank');
              }}
              icon={ICONS.app_store_icon}
              ariaLabel={this.t('navigation.open_ios_app', 'Open iOS app')}
              className="-mr-1 hidden md:block"
              color="var(--sidebar-text)"
            />
            <IconButton
              onClick={() => {
                addMixpanelEvent(MixpanelEvent.llm_support, {[MixPannelEnum.bots]: 'ChatGPT'});
                window.open('https://chatgpt.com/g/g-68ee1e210830819198cf35315ee7eeac-tradly-support', '_blank');
              }}
              icon={ICONS.chat_gpt_icon}
              ariaLabel={this.t('navigation.open_ai_support', 'Open Tradly ChatGPT support')}
              className=""
              color="var(--sidebar-text)"
            />
            <IconButton
              onClick={() => {
                addMixpanelEvent(MixpanelEvent.headerMenu, {Action: 'Youtube clicked'});
                window.open('https://www.youtube.com/channel/UCRpXlfFBX5nayubY70-IFEA', '_blank');
              }}
              icon={ICONS.youtube_icon}
              ariaLabel={this.t('navigation.open_youtube_channel', 'Open Tradly YouTube channel')}
              className=""
              color="var(--sidebar-text)"
            />
          </>
        )}
        {(!isSidebar || isExpand) && (
          <SaveButton
            onClickButton={() => window.open('https://calendly.com/jk-my/quick-meeting', '_blank')}
            showSaveBtn={true}
            title={this.t('navigation.demo', 'Demo')}
          />
        )}
        {/* <IconButton
          onClick={() => {
            addMixpanelEvent(MixpanelEvent.headerMenu, {
              Action: 'Referral clicked',
            });
            window.open('https://tradly.app/affiliate', '_blank');
          }}
          icon={ICONS.dollar_icon}
          className="md:px-2  mx-2"
        /> */}
        {/* <View style={{width: 15, height: 10}} /> */}
        <View style={{marginRight: 0, zIndex: 938}}>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showLogoutView: !this.state.showLogoutView,
                showHelpView: false,
              })
            }>
            <Image
              resizeMode={'center'}
              style={{height: 20, width: 20}}
              source={switch_Icon}
              accessibilityLabel={this.t('navigation.open_account_menu', 'Open account menu')}
            />
          </TouchableOpacity>
          {/* <this.logoutView /> */}
          <this.ecosystemMenu />
        </View>
      </View>
    );
  };
  render() {
    return this.renderHeaderRightView();
  }
}
export default withRouter(withLocale(AppNavigationHeader));

const styles = StyleSheet.create({
  headerView: {
    backgroundColor: colors.AppLightGreen,
    justifyContent: 'space-between',
    flexDirection: 'row',
    height: 70,
    alignItems: 'center',
    flex: 1,
  },
  headerSubView: {
    margin: 10,
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerContentView: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    zIndex: 1234,
  },
  logoutView: {
    // width: 80,
    backgroundColor: colors.AppWhite,
    position: 'absolute',
    top: 35,
    right: 10,
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
    alignItems: 'flex-start',
    borderColor: colors.SimonGray,
    borderWidth: 1,
    shadowColor: '#000000',
    shadowOpacity: 0.1,
    shadowOffset: {width: 0, height: 0},
    shadowRadius: 10,
    marginBottom: 20,
  },
  ecosystemMenu: {
    position: 'absolute',
    top: 35,
    right: 0,
    width: windowWidth < fixedWidth ? 320 : 440,
    maxWidth: '90vw',
    flexDirection: 'row',
    flexWrap: 'wrap',
    backgroundColor: '#171918',
    borderColor: '#4a4d4b',
    borderWidth: 1,
    borderRadius: 10,
    overflow: 'hidden',
    shadowColor: '#000000',
    shadowOpacity: 0.3,
    shadowOffset: {width: 0, height: 6},
    shadowRadius: 14,
    zIndex: 20,
  },
  ecosystemKit: {
    width: '50%',
    minHeight: 155,
    padding: 12,
    borderColor: '#4a4d4b',
    borderRightWidth: 1,
    borderBottomWidth: 1,
  },
  ecosystemKitHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  ecosystemNumber: {
    color: '#9a9d9c',
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 3,
  },
  ecosystemKitTitle: {
    color: '#ffffff',
    fontSize: 18,
    fontWeight: '700',
    marginTop: 4,
  },
  ecosystemDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    marginTop: 6,
  },
  ecosystemItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 6,
  },
  ecosystemIconBox: {
    width: 30,
    height: 30,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: '#4a4d4b',
    backgroundColor: '#111412',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
  },
  ecosystemIcon: {
    width: 18,
    height: 18,
  },
  ecosystemItemTitle: {
    color: '#f7f7f7',
    fontSize: 13,
    fontWeight: '600',
    flex: 1,
  },
  ecosystemAccountFooter: {
    width: '100%',
    borderTopWidth: 1,
    borderTopColor: '#4a4d4b',
    padding: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  ecosystemAccountDetails: {
    width: 'auto',
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
  },
  ecosystemAccountActionsRow: {
    width: 'auto',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
    marginLeft: 8,
  },
  ecosystemTenantName: {
    color: '#f7f7f7',
    fontSize: 12,
    fontWeight: '700',
  },
  ecosystemUserName: {
    color: '#9a9d9c',
    fontSize: 11,
    marginLeft: 10,
  },
  ecosystemAccountAction: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 6,
  },
  ecosystemThemeAction: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 7,
    color: '#f7f7f7',
  },
  ecosystemAccountIcon: {
    width: 18,
    height: 18,
    marginRight: 5,
  },
  ecosystemAccountActionText: {
    color: '#f7f7f7',
    fontSize: 12,
    fontWeight: '600',
  },
  logoStyle: {
    width: 50,
    height: 50,
  },
  menuBtnStyle: {
    width: 30,
    height: 30,
    margin: 10,
    marginLeft: 0,
  },
  searchViewStyle: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchBarViewStyle: {
    borderColor: colors.SimonGray,
    borderRadius: 10,
    borderWidth: 1,
    width: '50%',
    height: 35,
    alignItems: 'center',
    flexDirection: 'row',
  },
  environmentView: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: 10,
    flex: 1,
  },
  inviteBtnStyle: {
    marginTop: 10,
    backgroundColor: colors.AppNewGreen,
    height: 30,
    width: 70,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  inviteIconStyle: {
    width: 20,
    height: 20,
    marginLeft: 5,
  },

  moreViewContainerStyle: {
    marginTop: 10,
    marginRight: 20,
    alignItems: 'flex-end',
    width: '100%',
    borderWidth: 1,
    borderColor: colors.SimonGray,
    backgroundColor: 'white',
    borderRadius: 5,
    zIndex: 12,
  },
  openLinkStyle: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  linkiconstyle: {
    height: 14,
    width: 14,
    marginLeft: 10,
    marginTop: 2,
  },
  openLinkconstyle: {
    height: 14,
    width: 14,
    marginRight: 10,
  },
  iconStyle: {
    height: 18,
    width: 18,
    marginLeft: 12,
    marginTop: 2,
  },
  upgradeBtnStyle: {
    backgroundColor: colors.PaidBGColor,
    padding: 6,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: colors.PaidOutlineColor,
    height: 40,
  },
});
